import { render, staticRenderFns } from "./AddOrUpdateDoctorsNoteModal.vue?vue&type=template&id=dd3daf1e&"
import script from "./AddOrUpdateDoctorsNoteModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateDoctorsNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateDoctorsNoteModal.vue?vue&type=style&index=0&id=dd3daf1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports